import { call, put, select } from 'redux-saga/effects';

import { goToChannelsService } from './router';
import { createChannelRequest, deleteChannelRequest, updateChannelRequest } from '../requests';
import { pathSelector } from '../../../selectors';
import { createChannel, deleteChannel, updateChannel } from '../../../actions';

export function* createChannelService(data) {
  yield put(createChannel(data));

  const { success } = yield call(createChannelRequest, data);

  if (success) {
    yield call(goToChannelsService);
  }
}

export function* updateChannelService(id, data) {
  yield put(updateChannel(id, data));
  yield call(updateChannelRequest, id, data);
}

export function* updateCurrentChannelService(data) {
  const { channelId } = yield select(pathSelector);

  yield call(updateChannelService, channelId, data);
}

export function* deleteChannelService(id) {
  const { channelId } = yield select(pathSelector);

  if (id === channelId) {
    yield call(goToChannelsService);
  }

  yield put(deleteChannel(id));
  yield call(deleteChannelRequest, id);
}

export function* deleteCurrentChannelService() {
  const { channelId } = yield select(pathSelector);

  yield call(deleteChannelService, channelId);
}
